export default __webpack_public_path__ + "static/media/facebook.3f23e407.svg";